module.exports = __webpack_public_path__ + "img/phone.dc26363c.svg";